import { render, staticRenderFns } from "./chart-room-average.vue?vue&type=template&id=572715fc&scoped=true&"
import script from "./chart-room-average.vue?vue&type=script&lang=ts&"
export * from "./chart-room-average.vue?vue&type=script&lang=ts&"
import style0 from "./chart-room-average.vue?vue&type=style&index=0&id=572715fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572715fc",
  null
  
)

export default component.exports